// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Group from "@visx/group";
import * as Shape from "@visx/shape";
import * as PlRadarChart from "./PlRadarChart.bs.js";

function genPolygonPoints(data, access) {
  var step = Math.PI * 2 / data.length;
  var points = [];
  var pointsString = Belt_Array.reduce(Belt_Array.range(0, data.length - 1 | 0), "", (function (acc, i) {
          if (i > data.length) {
            return acc;
          }
          var x = Curry._1(access, Belt_Array.getExn(data, i)) * Math.sin(0 + Global.f(i) * step);
          var y = -1 * Curry._1(access, Belt_Array.getExn(data, i)) * Math.cos(0 + Global.f(i) * step);
          points.push([
                x,
                y
              ]);
          return acc + String(x) + "," + String(y) + " ";
        }));
  return [
          points,
          pointsString
        ];
}

function PlRadarChart2(Props) {
  var compositionsRating = Props.compositionsRating;
  var econRating = Props.econRating;
  var scoutingRating = Props.scoutingRating;
  var executionRating = Props.executionRating;
  var itemsRating = Props.itemsRating;
  var augmentsRating = Props.augmentsRating;
  var width = Props.width;
  var small = Props.small;
  var match = genPolygonPoints(Belt_Array.range(0, 5), (function (x) {
          switch (x) {
            case 0 :
                return 0.5 * 16 + 16 * 4 / 10 * PlRadarChart.truncate(compositionsRating);
            case 1 :
                return 0.5 * 16 + 16 * 4 / 10 * PlRadarChart.truncate(econRating);
            case 2 :
                return 0.5 * 16 + 16 * 4 / 10 * PlRadarChart.truncate(executionRating);
            case 3 :
                return 0.5 * 16 + 16 * 4 / 10 * PlRadarChart.truncate(scoutingRating);
            case 4 :
                return 0.5 * 16 + 16 * 4 / 10 * PlRadarChart.truncate(itemsRating);
            case 5 :
                return 0.5 * 16 + 16 * 4 / 10 * PlRadarChart.truncate(augmentsRating);
            default:
              throw {
                    RE_EXN_ID: "Assert_failure",
                    _1: [
                      "PlRadarChart2.res",
                      41,
                      11
                    ],
                    Error: new Error()
                  };
          }
        }));
  return React.createElement("svg", {
              width: String(width !== undefined ? width : (
                      small ? 180 : 200
                    )) + "px",
              viewBox: "0 0 200 232"
            }, React.createElement(Group.Group, {
                  children: null,
                  top: 116,
                  left: 100
                }, Belt_Array.map(Belt_Array.range(0, 4), (function (i) {
                        return React.createElement(Shape.LineRadial, {
                                    data: Belt_Array.range(0, 6),
                                    angle: (function (d) {
                                        return Math.PI * (d + 1 | 0) * 2 / 6;
                                      }),
                                    radius: (Global.f(i) + 0.5) * 16,
                                    fill: i === 4 ? "rgba(255, 255, 255, 0.1)" : "transparent",
                                    stroke: "var(--white2)",
                                    strokeLinecap: "round",
                                    key: String(i)
                                  });
                      })), React.createElement("polygon", {
                      fill: "var(--tertiary-9)",
                      fillOpacity: "0.4",
                      points: match[1],
                      stroke: "var(--tertiary-10)",
                      strokeWidth: "1.5"
                    }), Belt_Array.map(Belt_Array.range(0, 5), (function (i) {
                        var tmp;
                        switch (i) {
                          case 1 :
                              tmp = -10;
                              break;
                          case 2 :
                              tmp = -12;
                              break;
                          case 0 :
                          case 3 :
                              tmp = 0;
                              break;
                          case 4 :
                              tmp = 8;
                              break;
                          case 5 :
                              tmp = 16;
                              break;
                          default:
                            tmp = 0;
                        }
                        var tmp$1;
                        switch (i) {
                          case 0 :
                              tmp$1 = 0;
                              break;
                          case 3 :
                              tmp$1 = -2;
                              break;
                          case 2 :
                          case 4 :
                              tmp$1 = 2;
                              break;
                          case 1 :
                          case 5 :
                              tmp$1 = -6;
                              break;
                          default:
                            tmp$1 = 0;
                        }
                        var tmp$2;
                        switch (i) {
                          case 0 :
                              tmp$2 = "Compositions";
                              break;
                          case 1 :
                              tmp$2 = "Econ";
                              break;
                          case 2 :
                              tmp$2 = "Execution";
                              break;
                          case 3 :
                              tmp$2 = "Flexibility";
                              break;
                          case 4 :
                              tmp$2 = "Items";
                              break;
                          case 5 :
                              tmp$2 = "Augments";
                              break;
                          default:
                            throw {
                                  RE_EXN_ID: "Assert_failure",
                                  _1: [
                                    "PlRadarChart2.res",
                                    120,
                                    17
                                  ],
                                  Error: new Error()
                                };
                        }
                        return React.createElement("text", {
                                    key: String(i),
                                    className: CssJs.style([CssJs.unsafe("textShadow", "0 0 3px black")]),
                                    fill: "var(--white1)",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    textAnchor: "middle",
                                    x: String(100 * Math.sin(i * (2 / 6) * Math.PI) + tmp | 0),
                                    y: String((6 - (108 * Math.cos(i * (2 / 6) * Math.PI) | 0) | 0) + tmp$1 | 0)
                                  }, tmp$2);
                      })), React.createElement(PlRadarChart.Grade.make, {
                      x: 0,
                      y: -87,
                      grade: PlRadarChart.ratingToGrade(compositionsRating)
                    }), React.createElement(PlRadarChart.Grade.make, {
                      x: 78,
                      y: -36,
                      grade: PlRadarChart.ratingToGrade(econRating)
                    }), React.createElement(PlRadarChart.Grade.make, {
                      x: 78,
                      y: 36,
                      grade: PlRadarChart.ratingToGrade(executionRating)
                    }), React.createElement(PlRadarChart.Grade.make, {
                      x: 0,
                      y: 87,
                      grade: PlRadarChart.ratingToGrade(scoutingRating)
                    }), React.createElement(PlRadarChart.Grade.make, {
                      x: -78,
                      y: 36,
                      grade: PlRadarChart.ratingToGrade(itemsRating)
                    }), React.createElement(PlRadarChart.Grade.make, {
                      x: -78,
                      y: -36,
                      grade: PlRadarChart.ratingToGrade(augmentsRating)
                    })));
}

var make = PlRadarChart2;

export {
  genPolygonPoints ,
  make ,
  
}
/* CssJs Not a pure module */
